@if (model) {
  <span>Adults:</span><span>{{adultCount}}</span>
  <span>Children:</span><span>{{childCount}}</span>
}

